import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a740802"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "heading-4 f-roboto fw-light" }, "App config", -1))
const _hoisted_2 = { class: "white-box" }
const _hoisted_3 = { class: "d-flex flex-row" }
const _hoisted_4 = { class: "nav-item-wrapper" }
const _hoisted_5 = { class: "d-flex w-100" }
const _hoisted_6 = {
  key: 0,
  class: "w-100 page-box-wrapper"
}
const _hoisted_7 = { class: "d-flex flex-row w-100" }
const _hoisted_8 = { class: "page-box" }
const _hoisted_9 = { class: "input-box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Email Host", -1))
const _hoisted_11 = { class: "input-box" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Email Password", -1))
const _hoisted_13 = { style: {"position":"relative"} }
const _hoisted_14 = ["type"]
const _hoisted_15 = { class: "page-box" }
const _hoisted_16 = { class: "input-box" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Email Port", -1))
const _hoisted_18 = { class: "input-box" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Email Username", -1))
const _hoisted_20 = { class: "page-box" }
const _hoisted_21 = { class: "input-box" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "From Email Address", -1))
const _hoisted_23 = { class: "input-box" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Email Encryption", -1))
const _hoisted_25 = { class: "d-flex justify-content-end mt-20" }
const _hoisted_26 = {
  key: 1,
  class: "d-flex flex-row w-100 page-box-wrapper"
}
const _hoisted_27 = { class: "page-box" }
const _hoisted_28 = { class: "input-box" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Email From Name", -1))
const _hoisted_30 = { class: "input-box" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Email Footer", -1))
const _hoisted_32 = { class: "page-box" }
const _hoisted_33 = { class: "input-box" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Email Signature", -1))
const _hoisted_35 = { class: "page-box" }
const _hoisted_36 = { class: "input-box" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Email Headline", -1))
const _hoisted_38 = { class: "d-flex justify-content-end mt-80" }
const _hoisted_39 = {
  key: 2,
  class: "d-flex flex-row align-items-start w-100 page-box-wrapper"
}
const _hoisted_40 = {
  key: 0,
  class: "d-flex flex-column align-items-center justify-content-center w-100"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Setup email configuration first.", -1))
const _hoisted_42 = {
  key: 1,
  class: "d-flex align-items-end"
}
const _hoisted_43 = { class: "input-box" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Test email config:", -1))
const _hoisted_45 = { style: {"margin-bottom":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ShowEye = _resolveComponent("ShowEye")!
  const _component_HideEye = _resolveComponent("HideEye")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_RotateLoader = _resolveComponent("RotateLoader")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, {
    "no-sidebar": false,
    "no-search": true
  }, {
    "header-left": _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: _normalizeClass({
            'nav-item ': true,
            'nav-item-active': _ctx.activeTab == 1,
          }),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.activeTab = 1))
            }, " Email Configuration ", 2),
            _createElementVNode("div", {
              class: _normalizeClass({
            'nav-item ': true,
            'nav-item-active': _ctx.activeTab == 2,
          }),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 2))
            }, " Customize email design ", 2),
            _createElementVNode("div", {
              class: _normalizeClass([{
            'nav-item ': true,
            'nav-item-active': _ctx.activeTab == 3,
          }, "nav-item"]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTab = 3))
            }, " Send test email ", 2)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.activeTab == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formValues.mail_host) = $event)),
                          class: "input",
                          placeholder: "Enter mail host",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.formValues.mail_host]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formValues.mail_password) = $event)),
                            class: "input",
                            style: {"padding-right":"40px"},
                            placeholder: "Enter email password",
                            type: _ctx.isEmailPasswordVisible ? 'text' : 'password'
                          }, null, 8, _hoisted_14), [
                            [_vModelDynamic, _ctx.formValues.mail_password]
                          ]),
                          (_ctx.isEmailPasswordVisible)
                            ? (_openBlock(), _createBlock(_component_ShowEye, {
                                key: 0,
                                class: "password-eye",
                                onClick: _ctx.togglePasswordViewMode
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                          (!_ctx.isEmailPasswordVisible)
                            ? (_openBlock(), _createBlock(_component_HideEye, {
                                key: 1,
                                class: "password-eye",
                                onClick: _ctx.togglePasswordViewMode
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _hoisted_17,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formValues.mail_port) = $event)),
                          class: "input",
                          placeholder: "Enter email port",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.formValues.mail_port]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formValues.mail_username) = $event)),
                          class: "input",
                          placeholder: "Enter email username",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.formValues.mail_username]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formValues.mail_from_address) = $event)),
                          class: "input",
                          placeholder: "Enter from email address",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.formValues.mail_from_address]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _hoisted_24,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formValues.mail_encryption) = $event)),
                          class: "input",
                          placeholder: "Enter email encryption",
                          type: "text"
                        }, null, 512), [
                          [_vModelText, _ctx.formValues.mail_encryption]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_BaseButton, {
                      class: "mt-40",
                      onClick: _ctx.saveEmailConfiguration
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Save email configuration")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.activeTab == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formValues.mail_from_name) = $event)),
                        class: "input",
                        placeholder: "Enter email from name",
                        type: "text"
                      }, null, 512), [
                        [_vModelText, _ctx.formValues.mail_from_name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formValues.mail_footer) = $event)),
                        class: "input",
                        placeholder: "Enter email footer",
                        type: "text"
                      }, null, 512), [
                        [_vModelText, _ctx.formValues.mail_footer]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formValues.mail_signature) = $event)),
                        class: "input",
                        placeholder: "Enter email signature",
                        type: "text",
                        rows: "3"
                      }, null, 512), [
                        [_vModelText, _ctx.formValues.mail_signature]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formValues.mail_headline) = $event)),
                        class: "input",
                        placeholder: "Enter email headline",
                        type: "text"
                      }, null, 512), [
                        [_vModelText, _ctx.formValues.mail_headline]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createVNode(_component_BaseButton, {
                        class: "mt-40",
                        onClick: _ctx.saveCustomizedEmailDesign
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Save email design")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.activeTab == 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                  (!_ctx.isEmailConfigurationCompleted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                        _hoisted_41,
                        _createVNode(_component_BaseButton, {
                          variant: "base",
                          disabled: _ctx.isRequestingTestEmail,
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.activeTab = 1))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Take me there ")
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isEmailConfigurationCompleted)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _hoisted_44,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.testEmail) = $event)),
                            style: {"min-width":"320px"},
                            class: "input",
                            placeholder: "Enter test email",
                            type: "text"
                          }, null, 512), [
                            [_vModelText, _ctx.testEmail]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_45, [
                          _createVNode(_component_BaseButton, {
                            variant: "base",
                            disabled: _ctx.isRequestingTestEmail,
                            onClick: _ctx.testEmailConfig
                          }, {
                            default: _withCtx(() => [
                              (_ctx.isRequestingTestEmail)
                                ? (_openBlock(), _createBlock(_component_RotateLoader, { key: 0 }))
                                : _createCommentVNode("", true),
                              _createTextVNode(" Send test request ")
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}